import TagManager from 'react-gtm-module'

interface TagManagerArgs {
  gtmId: string
  auth: string
  preview: string
}

export interface DataLayerEvent {
  event: string
  user_origin?: string
  interaction_uuid?: string
  interaction_name?: string
  clicked_button?: string
  current_step?: number
}

export enum Events {
  INTERACTION_START = 'interaction_start',
  INTERACTION_PROGRESS = 'interaction_progress',
  INTERACTION_COMPLETE = 'interaction_complete'
}

export function initialize(tagManagerArgs: TagManagerArgs) {
  TagManager.initialize(tagManagerArgs)
}

export function setDataLayer(dataLayer: DataLayerEvent) {
  window.dataLayer.push(dataLayer)
}

export const getOriginFromUrl = (): string => {
  const urlParams = new URLSearchParams(window.location.search)
  const utmSource = urlParams.get('utm_source')

  if (utmSource) {
    return `${utmSource}_campaign_data`
  }

  if (document.referrer && document.referrer !== '') {
    const referrerDomain = new URL(document.referrer).hostname
    return `referrer_${referrerDomain}`
  }

  return 'direct'
}
